var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _circle, _path47, _path48, _path49, _path50, _path51, _g2, _path52, _g3, _path53, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNpwp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 241,
    viewBox: "0 0 336 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M166.5 226.922C256.191 226.922 328.9 223.019 328.9 218.203C328.9 213.388 256.191 209.484 166.5 209.484C76.8086 209.484 4.09961 213.388 4.09961 218.203C4.09961 223.019 76.8086 226.922 166.5 226.922Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M74.8651 32.7628C41.837 44.547 17.3451 74.4286 12.5137 110.573C8.45369 141.023 25.1301 178.578 83.1475 180.313C210.763 184.14 293.963 195.143 312.081 141.155C331.548 83.117 320.992 18.6645 264.477 13.082C219.533 8.64642 139.358 9.75277 74.8651 32.7628Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.335 29.6064H65.8828V189.946H291.335V29.6064Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.57 57.752H95.4802C90.6424 57.752 86.7207 61.6737 86.7207 66.5114V162.307C86.7207 167.145 90.6424 171.067 95.4802 171.067H260.57C265.408 171.067 269.329 167.145 269.329 162.307V66.5114C269.329 61.6737 265.408 57.752 260.57 57.752Z",
    fill: "#24285B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M134.954 143.57H100.729V152.35H134.954V143.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M175.077 143.57H140.852V152.35H175.077V143.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M215.2 143.57H180.975V152.35H215.2V143.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M255.323 143.57H221.098V152.35H255.323V143.57Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M95.5822 117.576L82.8541 117.921L78.6621 191.052H96.9321C97.9471 187.57 100.586 169.463 110.513 158.978C120.267 148.655 160.146 121.9 145.54 103.833C138.435 95.0328 126.499 128.629 126.499 128.629L107.63 130.903L108.919 130.233L95.5822 117.576Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5272 99.3161L69.6282 105.629L64.6344 108.806L62.8379 97.8545L67.5272 99.3161Z",
    fill: "#F4A28C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1218 91.7441C61.3845 91.1442 61.7927 90.6193 62.3093 90.2169C62.826 89.8145 63.4349 89.5473 64.0808 89.4395C64.7267 89.3317 65.3894 89.3866 66.0088 89.5994C66.6281 89.8122 67.1846 90.176 67.6279 90.6581C69.7493 92.9317 72.3172 96.5451 69.4143 98.504C64.9788 101.549 60.8985 95.8955 60.8985 95.8955C60.5574 94.5204 60.6351 93.0747 61.1218 91.7441Z",
    fill: "#F4A28C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3709 95.6416C64.3709 95.6416 63.2239 94.6875 62.7164 96.0476C62.2089 97.4077 64.2085 98.0776 64.8073 97.3671C65.4062 96.6566 64.3709 95.6416 64.3709 95.6416Z",
    fill: "#F4A28C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3226 111.993C54.3226 111.993 33.7587 124.437 31.0487 153.669C30.815 156.096 31.4629 158.526 32.8737 160.515C34.2846 162.504 36.3642 163.918 38.7322 164.499L62.8385 170.315L54.3226 111.993Z",
    fill: "#0D9F3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.3226 111.993C54.3226 111.993 33.7587 124.437 31.0487 153.669C30.815 156.096 31.4629 158.526 32.8737 160.515C34.2846 162.504 36.3642 163.918 38.7322 164.499L62.8385 170.315L54.3226 111.993Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9998 93.9871C64.9998 93.9871 67.3648 100.747 63.254 100.321C59.1433 99.8944 61.3864 96.9915 59.3463 93.9871C57.3061 90.9827 58.3313 88.9121 61.4981 86.3036C62.9292 85.0957 63.8833 84.5273 64.4619 83.8879C64.7039 83.6032 65.014 83.3845 65.3634 83.2521C65.7127 83.1196 66.0899 83.0778 66.4598 83.1305C66.8296 83.1832 67.1801 83.3287 67.4786 83.5534C67.7771 83.7781 68.0138 84.0748 68.1666 84.4157C69.2222 87.0141 69.2324 90.4854 64.9998 93.9871Z",
    fill: "#24285B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5621 118.104C50.5391 115.94 51.9703 114.011 53.7584 112.449C55.5464 110.887 57.6496 109.728 59.9252 109.05C68.7253 106.411 85.422 100.869 90.3752 109.05C97.125 120.306 86.7314 164.51 86.7314 164.51L57.1847 166.804C57.1847 166.804 40.9244 137.531 49.5621 118.104Z",
    fill: "#0D9F3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7211 164.551L82.8337 215.352H76.6929L71.2018 175.878L57.6211 166.845L86.7211 164.551Z",
    fill: "#24285B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6217 166.844L49.1465 215.351H55.7338L69.954 175.055L57.6217 166.844Z",
    fill: "#24285B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M62.4935 108.278C62.4935 108.278 48.6692 152.786 88.579 155.74L86.7215 164.55L57.1749 166.844C50.3853 154.872 46.9425 141.293 47.2076 127.533C47.2076 127.533 47.4613 116.185 55.4494 111.161C57.565 109.709 59.9668 108.726 62.4935 108.278Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6607 215.351L86.5076 218.396C86.6535 218.513 86.7596 218.673 86.8114 218.854C86.8633 219.034 86.8584 219.226 86.7974 219.403C86.7365 219.581 86.6223 219.735 86.4706 219.845C86.3189 219.955 86.1369 220.016 85.9493 220.02H81.0672C80.3771 220.017 79.7162 219.741 79.2292 219.252C78.7422 218.763 78.4687 218.101 78.4688 217.411V215.381L82.6607 215.351Z",
    fill: "#0D9F3F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6121 215.351L45.7653 218.396C45.6194 218.514 45.5133 218.674 45.4614 218.854C45.4095 219.034 45.4144 219.226 45.4754 219.404C45.5364 219.581 45.6505 219.735 45.8022 219.846C45.954 219.956 46.136 220.017 46.3235 220.02H51.1955C51.5441 220.024 51.8899 219.958 52.2126 219.826C52.5353 219.695 52.8283 219.5 53.0744 219.253C53.3204 219.006 53.5144 218.712 53.645 218.389C53.7755 218.065 53.84 217.719 53.8345 217.371V215.341L49.6121 215.351Z",
    fill: "#0D9F3F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M143.094 104.513L138.659 103.224L119.232 120.103C117.801 121.345 116.067 122.187 114.207 122.544C112.346 122.9 110.424 122.759 108.635 122.133C103.339 120.332 98.8354 116.743 95.8968 111.983C88.9136 100.646 77.0483 104.746 77.0483 104.746C77.0483 104.746 68.1061 113.556 85.8179 128.67C96.3942 137.693 107.224 138.261 114.238 137.257C115.094 137.153 115.954 137.096 116.816 137.084C117.644 137.056 118.46 136.873 119.222 136.546C120.164 136.143 121.082 135.685 121.972 135.176C129.158 131.085 136.903 122.295 143.094 104.513Z",
    fill: "#0D9F3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.094 104.513L138.659 103.224L119.232 120.103C117.801 121.345 116.067 122.187 114.207 122.544C112.346 122.9 110.424 122.759 108.635 122.133C103.339 120.332 98.8354 116.743 95.8968 111.983C88.9136 100.646 77.0483 104.746 77.0483 104.746C77.0483 104.746 68.1061 113.556 85.8179 128.67C96.3942 137.693 107.224 138.261 114.238 137.257C115.094 137.153 115.954 137.096 116.816 137.084C117.644 137.056 118.46 136.873 119.222 136.546C120.164 136.143 121.082 135.685 121.972 135.176C129.158 131.085 136.903 122.295 143.094 104.513Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M138.658 103.224C138.658 103.224 141.125 96.1195 143.094 95.6221C145.063 95.1248 143.094 99.4182 143.094 99.4182C143.094 99.4182 148.473 102.057 143.094 104.493L138.658 103.224Z",
    fill: "#F4A28C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M212.175 204.318C212.175 204.318 201.771 201.476 199.518 191.793C199.518 191.793 215.626 188.545 216.082 205.17L212.175 204.318Z",
    fill: "#0D9F3F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M213.403 203.283C213.403 203.283 206.146 191.803 212.53 181.064C212.53 181.064 224.781 188.839 219.341 203.303L213.403 203.283Z",
    fill: "#0D9F3F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215.281 203.293C215.281 203.293 219.118 191.164 230.719 188.87C230.719 188.87 232.891 196.736 223.208 203.324L215.281 203.293Z",
    fill: "#0D9F3F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M207.74 203.019L209.841 217.442L223.117 217.492L225.076 203.09L207.74 203.019Z",
    fill: "#24285B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0251 46.0795C95.7551 46.0795 97.9681 43.8664 97.9681 41.1364C97.9681 38.4064 95.7551 36.1934 93.0251 36.1934C90.2951 36.1934 88.082 38.4064 88.082 41.1364C88.082 43.8664 90.2951 46.0795 93.0251 46.0795Z",
    fill: "#FFD200"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106.929 46.0795C109.659 46.0795 111.872 43.8664 111.872 41.1364C111.872 38.4064 109.659 36.1934 106.929 36.1934C104.199 36.1934 101.986 38.4064 101.986 41.1364C101.986 43.8664 104.199 46.0795 106.929 46.0795Z",
    fill: "#0D9F3F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M120.246 46.0795C122.976 46.0795 125.189 43.8664 125.189 41.1364C125.189 38.4064 122.976 36.1934 120.246 36.1934C117.516 36.1934 115.303 38.4064 115.303 41.1364C115.303 43.8664 117.516 46.0795 120.246 46.0795Z",
    fill: "#24285B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M256.581 35.4824V100.98H197.711V35.4824L200.38 40.8213L203.06 35.4824L205.74 40.8213L208.419 35.4824L211.099 40.8213L213.768 35.4824L216.448 40.8213L219.117 35.4824L221.797 40.8213L224.466 35.4824L227.146 40.8213L229.815 35.4824L232.495 40.8213L235.175 35.4824L237.844 40.8213L240.524 35.4824L243.193 40.8213L245.873 35.4824L248.552 40.8213L251.232 35.4824L253.901 40.8213L256.581 35.4824Z",
    fill: "#F4F4F4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M221.725 44.8008H204.277V46.3943H221.725V44.8008Z",
    fill: "#E6E6E6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M250.014 44.8008H234.129V46.3943H250.014V44.8008Z",
    fill: "#E6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M214.488 52.6162H204.277V54.2098H214.488V52.6162Z",
    fill: "#E6E6E6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M250.014 52.6162H234.129V54.2098H250.014V52.6162Z",
    fill: "#E6E6E6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M250.015 60.4219H235.033V62.0154H250.015V60.4219Z",
    fill: "#E6E6E6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M217.33 60.4219H204.277V62.0154H217.33V60.4219Z",
    fill: "#E6E6E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M219.665 68.2266H204.277V69.8201H219.665V68.2266Z",
    fill: "#E6E6E6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M250.015 68.2266H234.516V69.8201H250.015V68.2266Z",
    fill: "#E6E6E6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M214.103 76.042H204.277V77.6355H214.103V76.042Z",
    fill: "#E6E6E6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M250.015 76.042H235.033V77.6355H250.015V76.042Z",
    fill: "#E6E6E6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M250.013 83.8477H204.277V85.4412H250.013V83.8477Z",
    fill: "#E6E6E6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M250.015 91.6533H229.35V93.2469H250.015V91.6533Z",
    fill: "#E6E6E6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M180.579 116.259L178.595 110.679L176.832 116.259L179.215 122.831H182.439L186.407 109.688H182.191L180.579 116.259Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M171.776 112.292H167.932L171.032 123.08L173.14 117.128L171.776 112.292Z",
    fill: "#FFE200"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M171.033 123.08L178.101 102H181.449L174.753 123.08H171.033Z",
    fill: "#FFD929"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.152 109.688V130.396H160.12V122.088C160.451 122.418 161.484 123.08 162.972 123.08C164.832 123.08 167.312 122.088 167.312 119.856V112.788C167.312 111.672 166.097 109.465 163.22 109.564C160.344 109.663 160.12 110.184 160.12 110.68V109.688H156.152ZM161.733 113.284C162.105 113.284 163.221 113.284 163.221 114.028V118.244C163.263 118.616 163.023 119.36 161.733 119.36C160.444 119.36 160.204 118.616 160.245 118.244V114.524C160.245 114.111 160.543 113.284 161.733 113.284Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.152 109.688V130.396H191.12V122.088C191.451 122.418 192.484 123.08 193.972 123.08C195.832 123.08 198.312 122.088 198.312 119.856V112.788C198.312 111.672 197.097 109.465 194.22 109.564C191.344 109.663 191.12 110.184 191.12 110.68V109.688H187.152ZM192.733 113.284C193.105 113.284 194.221 113.284 194.221 114.028V118.244C194.263 118.616 194.023 119.36 192.733 119.36C191.444 119.36 191.204 118.616 191.245 118.244V114.524C191.245 114.111 191.543 113.284 192.733 113.284Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M144 123.204V109.812H147.844V110.556C147.844 110.556 147.894 109.812 151.068 109.812C154.416 109.812 154.912 112.044 154.912 113.284V123.204H151.068V114.4C150.944 114.028 150.423 113.284 149.332 113.284C148.241 113.284 147.968 114.028 147.968 114.4V123.204H144Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 203.025,
    cy: 119.855,
    r: 2.97599,
    fill: "#FFD929"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M183.206 50.332H150.422V83.1165H183.206V50.332Z",
    fill: "#F4F4F4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M178.608 56.0469H156.715V57.7521H178.608V56.0469Z",
    fill: "#E6E6E6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M178.608 62.9082H156.715V64.6134H178.608V62.9082Z",
    fill: "#E6E6E6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M172.183 69.7793H156.715V71.4845H172.183V69.7793Z",
    fill: "#E6E6E6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M307.464 205.09H252.969V216.722H307.464V205.09Z",
    fill: "#FFD200"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M262.569 205.09H258.996V216.722H262.569V205.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M272.294 205.09H268.721V216.722H272.294V205.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M282.006 205.09H278.434V216.722H282.006V205.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M291.719 205.09H288.146V216.722H291.719V205.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M301.444 205.09H297.871V216.722H301.444V205.09Z",
    fill: "white"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M301.435 193.468H246.939V205.1H301.435V193.468Z",
    fill: "#FFD200"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M256.542 193.468H252.969V205.1H256.542V193.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M266.266 193.468H262.693V205.1H266.266V193.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M275.979 193.468H272.406V205.1H275.979V193.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M285.692 193.468H282.119V205.1H285.692V193.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M295.417 193.468H291.844V205.1H295.417V193.468Z",
    fill: "white"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M307.464 181.836H252.969V193.468H307.464V181.836Z",
    fill: "#FFD200"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M262.569 181.836H258.996V193.468H262.569V181.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M272.294 181.836H268.721V193.468H272.294V181.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M282.006 181.836H278.434V193.468H282.006V181.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M291.719 181.836H288.146V193.468H291.719V181.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M301.444 181.836H297.871V193.468H301.444V181.836Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpwp);
export default __webpack_public_path__ + "static/media/npwp.5ccfa2fe64ee6b9a30852e1f6c360bc9.svg";
export { ForwardRef as ReactComponent };